const socialMediaData = ['Instagram', 'LinkedIn', 'X', 'Facebook']

export default socialMediaData
